export function isValidUKPostcode(postcode) {
    const postcodeRegex = /^(GIR 0AA|(?:[A-Z]{1,2}\d{1,2}[A-Z]?) ?\d[A-Z]{2})$/i;
    const trimmedPostcode = postcode.trim();
    
    return postcodeRegex.test(trimmedPostcode);
  }